import Lenis from 'lenis';

// PC サイト（SPブレークポイント @media (max-width: 700px) 外）でのみスムーズスクロールを有効化
if (window.matchMedia('(min-width: 701px)').matches) {
  new Lenis({
    autoRaf: true,
    anchors: true,
    smoothWheel: true,
    allowNestedScroll: true,
    lerp: 0.135,
    wheelMultiplier: 1.14,
  });
}
